import { render, staticRenderFns } from "./RicercaPosizione.vue?vue&type=template&id=28db2396"
import script from "./RicercaPosizione.vue?vue&type=script&lang=js"
export * from "./RicercaPosizione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports